import { render, staticRenderFns } from "./DoorCard.vue?vue&type=template&id=22051d96&scoped=true&"
import script from "./DoorCard.vue?vue&type=script&lang=js&"
export * from "./DoorCard.vue?vue&type=script&lang=js&"
import style0 from "./DoorCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DoorCard.vue?vue&type=style&index=1&id=22051d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22051d96",
  null
  
)

export default component.exports